export default __webpack_public_path__ + "static/media/logo.bf3c2ce9.jpg";